import React from 'react'
import {BsArrowRight} from "react-icons/bs";
import heroImg from "../../asstes/images/HeroImg.png"
import {useNavigate} from "react-router-dom"

const Hero = () => {

  const navigate = useNavigate()

  return (
    <div className='xl:pt-[150px] lg:pt-[10px] pt-[90px] bg-[#4285F4] xl:h-[900px] lg:h-[760px] flex items-center'>
    <div className='container'>
    <div className='flex items-center flex-col lg:flex-row justify-between gap-5'>
        <div className='flex-1'>
            <h2 className='md:text-[64px] md:leading-[75px] text-[32px] leading-[35px]  font-bold text-white'>Tu contabilidad fácil, segura y online</h2>
            <p className='md:text-[24px] text-[14px] py-5 text-white'>Regístrate y descárga la app para empezar</p>
            <div className=' bg-white md:w-[450px] w-auto shadow-md rounded-md flex items-center justify-between'>
                <input type="text" className='md:text-[24px] text-[14px] px-2 md:w-[70%] w-[60%] outline-none' name="" id="" placeholder='Correo electrónico' />
                <button onClick={()=>navigate("/signup")} className='py-3 md:text-[25px] bg-[#CAD8EF] flex items-center gap-2 md:w-[30%] w-[40%] rounded-r-md px-5' >Iniciar <BsArrowRight className='text-[25px] md:mt-2'/></button>
            </div>
        </div>
        <div className='flex-1 lg:relative h-[710px]'>
            <div className=' lg:absolute left-0 -bottom-[20px]'>
              <img src={heroImg} alt="" className='w-[100%] h-[100%]' />
            </div>
        </div>
    </div>
    </div>
</div>
  )
}

export default Hero